import { GetHvJson, HvHostMap } from './helpers';
import { StaticVideo } from 'types/working-model';

export const GetSessionStaticVideos = async (eventUuid: string, sessionUuid: string) => {
	return await GetHvJson<Record<string, StaticVideo>>({
		path: `/e3-get-session-static-videos/${eventUuid}/${sessionUuid}`,
		service: HvHostMap.eventData
	});
};